import { useEffect } from 'react';

interface PopupContainerProps {
    isOpen: boolean;
    onClose: () => void;
    Component: React.ComponentType<any>;
    props?: any;
}

const PopupContainer = ({ isOpen, onClose, Component, props}: PopupContainerProps) => {
    useEffect(() => {
        if (isOpen) {
            // Disable scrolling when the popup is open
            document.body.style.overflow = "hidden";
        } else {
            // Re-enable scrolling when the popup is closed
            document.body.style.overflow = "auto";
        }

        // Clean up the effect when the component unmounts or popup is closed
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);
    
    if (!isOpen || !Component) return null;

    return (
        <div id="generic-popup" className="modal-popup" style={{display: "block"}} onClick={onClose}>
            <div className="modal-aligner" onClick={(e) => e.stopPropagation()}>
                <div className="dynamic-margin" style={{ flex: "1 1 auto" }}>
                    <div id="generic-popup-container" className="modal-container">
                        <span className="modal-close" onClick={ onClose }> x </span>
                        <div className="modal-popup-content">
                            <Component {...props} />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopupContainer;
